// removed by extract-text-webpack-plugin
module.exports = {"ribbon":"_3G6Zb988LViY_1u0HpjGAV","blue":"_2gw5_zwav9W2Jwgm_Hfz9z"};


//////////////////
// WEBPACK FOOTER
// ./src/Ribbon.css
// module id = 543
// module chunks = 0